import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { APIContainer, LogTypes, sawinFunc } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as CustomerFeedbackMdl from '../models/CustomerFeedbackModel';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.


export interface CustomerFeedbackListLoading { type: 'CUSTOMERFEEDBACKLIST_LOADING', loading: boolean }
export interface CustomerFeedbackListLoadInfo { type: 'CUSTOMERFEEDBACKLIST_LOADINFO', data: CustomerFeedbackMdl.CustomerFeedbackListModel }
export interface CustomerFeedbackListError { type: 'CUSTOMERFEEDBACKLIST_ERROR' , error: string}

export type KnownAction = CustomerFeedbackListLoading | CustomerFeedbackListLoadInfo | CustomerFeedbackListError ;

export const actionCreators = {
    loadFeedbacks: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;
        var ServiceMasterNum = sessionState.SelectedSM.id;
        var CompanyCode = sessionState.SelectedAR.companyCode;        
        
        dispatch({ type: 'CUSTOMERFEEDBACKLIST_LOADING', loading: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/Feedback?CompanyCode=${CompanyCode}&ServiceMasterNum=${ServiceMasterNum}`,
            {
                method: 'GET',                
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {                
                //Do something with response                
                if (container.success) {
                    const data: CustomerFeedbackMdl.CustomerFeedbackModel[] = container.data;
                    dispatch({ type: 'CUSTOMERFEEDBACKLIST_LOADINFO', data: { items: data, loading: false, error: '' } });  
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }

            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'CUSTOMERFEEDBACKLIST_ERROR', error: err.message
                })
            });
    }
};

export const reducer: Reducer<CustomerFeedbackMdl.CustomerFeedbackListModel> = (state: CustomerFeedbackMdl.CustomerFeedbackListModel | undefined, incomingAction: Action): CustomerFeedbackMdl.CustomerFeedbackListModel => {

    if (state === undefined) {
        return { ...CustomerFeedbackMdl.initialListState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'CUSTOMERFEEDBACKLIST_LOADING':
            return { ...state, loading: (action as CustomerFeedbackListLoading).loading }      
        case 'CUSTOMERFEEDBACKLIST_ERROR':            
            return { ...state, loading: false, error: (action as CustomerFeedbackListError).error }        
        case 'CUSTOMERFEEDBACKLIST_LOADINFO':
            return { ...state, ...(action as CustomerFeedbackListLoadInfo).data } 
        default:
            return state;
    }
}; 